

// import axios, { AxiosRequestConfig } from 'axios';
// import { HOST_API } from 'src/config-global';

// const axiosInstance = axios.create({ baseURL: HOST_API });

// axiosInstance.interceptors.request.use((config) => {
//   const token = sessionStorage.getItem('accessToken');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// axiosInstance.interceptors.response.use(
//   (res) => res,
//   (error) => {
//     // console.log("errrrrrrrrrrrrrrrrrrr",error.response.data.message,error?.response?.status)
//     if (error?.response?.status === 401) {
//       // 🔔 Trigger global event
      // const event = new CustomEvent('sessionExpired');
      // window.dispatchEvent(event);

//       return Promise.reject(new Error(error.response.data.message, error));
//     }

//     return Promise.reject((error.response && error.response.data) || new Error('Something went wrong'));
//   }
// );

// export default axiosInstance;



// // ---------------------------------------------------------------------- 

// export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
//   const [url, config] = Array.isArray(args) ? args : [args];

//   const res = await axiosInstance.get(url, { ...config });

//   return res.data;
// };



// export const mutationFetcher = async (
//   args: string | [string, any, "POST" | "PUT" | "DELETE" | "PATCH"],
//   postData?: any,
//   method?: "POST" | "PUT" | "DELETE" | "PATCH"
// ) => {
//   try {
//     const [url, data, httpMethod] = Array.isArray(args)
//       ? args
//       : [args, postData, method || "POST"];

//     // 👇 Determine if payload is FormData
//     const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

//     const res = await axiosInstance({
//       method: httpMethod,
//       url,
//       data: isFormData ? data : JSON.stringify(data),
//       headers: {
//         ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
//       },
//     });

//     // console.log("Response Data:", res.data);
//     return res.data;
//   } catch (error: any) {
//     console.error("API Error:", error.response?.data || error.message);
//     throw new Error(error.response?.data?.message || "API request failed!");
//   }
// };


// // ----------------------------------------------------------------------

// export const endpoints = {
//   chat: '/api/chat',
//   kanban: '/api/kanban',
//   calendar: '/api/calendar',
//   auth: {
//     me: '/user',
//     login: '/login',
//     register: '/api/auth/register',
//     verify2FA: 'verify-otp',
//     resend2FA: 'resend-otp',
//   },
//   mail: {
//     list: '/api/mail/list',
//     details: '/api/mail/details',
//     labels: '/api/mail/labels',
//   },
//   post: {
//     list: '/api/post/list',
//     details: '/api/post/details',
//     latest: '/api/post/latest',
//     search: '/api/post/search',
//   },
//   product: {
//     list: '/api/product/list',
//     details: '/api/product/details',
//     search: '/api/product/search',
//   },

//   comany: {

//     getCompany: '/companylist',
//     postCompany: '/company',
//     deleteCompany: '/company',
//     putCompany: '/companies',
//     preFillCompany: '/company',
//     serviceCompany: '/service',
//     companyDropdown: '/getAllCompanywithChildren'

//   },
//   users: {
//     getuserapi: '/user',
//     createUser: '/user',
//     getByIdUser: (id: any) => `/user/${id}`,
//     editUser: (id: any) => `/user/${id}`,
//     deleteUser: (id: any) => `/user/${id}`,
//     tokenListUser: "tokenList",
//     getUserId: '/user',

//   },


//   service: {

//     getserviceapi: '/service',
//     getserviceByIdapi: '/serviceById',
//     putservice: '/service',
//     postservice: '/service',
//     serviceCompany: '/company-services',


//   },
//   report: {
//     getReport: '/report',
//     addReport: '/report',
//     companyReport: '/companyReport',
//     moduletotalchart: "/module-vs-total",
//     takedownrequestchart: "/takedownreq-vs-completed",
//     modulewisebreakup: '/modulewise-breakup',
//     averagetakedown: '/average-takedown-time',
//     cumulativetakedown: '/cumulative-takedown-trend',
//     socialmediadetection: 'social-media-detection',
//     darkwebmentions: '/dark-web-mentions',
//     tattakedowns: '/takedowns-commulative',
//     getreportbyid: (id: any) => `/report/${id}`,
//     editreport: (id: any) => `/report/${id}`,
//   },

//   schedulereport: {
//     schedulepost: '/schedulers',
//     getscheduleapi: '/schedulers',
//     deleterow: (id: any) => `/schedulers/${id}`,
//     getbyid: (id: any) => `/schedulers/${id}`,
//     editschedulereport: (id: any) => `/schedulers/${id}`,
//   },

//   alert: {
//     getAlert: '/alertsByGroupedCompanyId',
//     getPostView: '/alertsByCompanyIdServiceId',
//     alertPost: '/alert',
//     alertdelete: '/alert',
//     alertPreFill: '/GetAlertDetailsById',
//     alertPutUpdate: '/alert',
//     alertDashboard: '/AlertsByCompanyId',
//     getalertusercase: 'AlertsReportedToUser',
//     apiforDashboard: '/dashboard',
//     zipUplode: '/upload-zip',
//     updateTackdownDate: '/alert',
//     downloadSheet: '/download-sample-sheet',
//     takedownByGroupedCompanyId: '/takedownByGroupedCompanyId',
//     dashboardissuefilter:'filterAlerts'

//   },
//   toakedownrequest: {
//     getbyidtakedown: '/takedowns',
//     updatesingletakedown: '/alert',
//     bulkUpdateStatus: '/bulkUpdateStatus',
//     bulkTakedownsRequested: 'bulkTakedownsRequested',
//     singleUserrequest: (id: string | number) => `/alert/${id}`
//   },
//   generatedToken: {
//     ganerateToken: '/login',
//     swaggerAPIs: '/documentation'

//   },
//   treegraph: {
//     treegraphget: '/charts/social_media_API'
//   },
//   BulkUpload: {

//     BulkUpload: '/BulkImportData'

//   },

//   Roles: {

//     Roles: '/roles',
//     EditRoles: "/roles",

//   },
//   swagger: {

//     documentation: '/documentation'

//   },
//   VendorPerformance: {
//     VendorPerformance: '/vendor-performances',
//     updateVendorPerformance: '/vendor-performances',
//   },

//   search: {
//     search: '/search'
//   },


//   asmreport: {
//     addreport: '/backend/reports',
//     editreport: '/reports',
//     deletereport: '/reports'
//   },

//   attcksurface: {
//     totalAssets: "/stats/total-assets",
//     ScoreChart: "vulnerabilities/score?status=open",
//     byrating: "vulnerabilities/by-rating?status=open",
//     issuefound: "/vulnerabilities/latest",
//     techtable: "techs",
//     assetsFound: "assets/all",
//     map: 'map?size=10000&isRootCandidate=false&isFalsePositive=false&includeRootAsset=true',
//     allissue: '/vulnerabilities',
//     issueoverviewfirst: '/vulnerabilities/by-rating',
//     issueoverviewtable: '/vulnerabilities-unique',
//     asmreport: 'reports'
//   },

//   attcksurfaceassets: {

//     customMeta: "/asset/custom-meta",
//     overViewTable:"/assets"

//   } 

// };




// with refresh token ===============================================================================================




import axios, { AxiosRequestConfig } from 'axios';
import { HOST_API } from 'src/config-global';

/* ------------------------------------------------------------------ */
/* Axios instance */
/* ------------------------------------------------------------------ */

const axiosInstance = axios.create({
  baseURL: HOST_API,
});


let isRefreshing = false;

let failedQueue: {
  resolve: (token: string) => void;
  reject: (error: any) => void;
}[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token as string);
    }
  });
  failedQueue = [];
};

/* ------------------------------------------------------------------ */
/* Refresh token API */
/* ------------------------------------------------------------------ */

const refreshTokenRequest = async () => {
const refresh_token =
  typeof window !== "undefined"
    ? localStorage.getItem('refresh_token') !== 'undefined'
      ? localStorage.getItem('refresh_token')
      : null
    : null;

  if (!refresh_token) {
    throw new Error('No refresh token available');
  }

  const response = await axios.post(
    `${HOST_API}/refresh`,
    {
      refresh_token, // ✅ property shorthand
    }
  );

  // console.log('Refresh response:', response.data);

  return response.data;
};




axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('accessToken');
  // console.log("config-----------",config)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    const code = error.response?.data?.code;

    // 🌐 Network / CORS error
    if (!error.response) {
      return Promise.reject(error);
    }

    // 🚪 Same user logged in elsewhere
    if (code === 'SESSION_EXPIRED') {
      sessionStorage.clear();
      localStorage.clear();

      window.dispatchEvent(
        new CustomEvent('sessionExpired', {
          detail: { reason: 'logged_elsewhere' },
        })
      );

      return Promise.reject(error);
    }

    // ⛔ Refresh API itself failed → force logout
    if (
      originalRequest.url?.includes('/api/v1/refresh') &&
      status === 401
    ) {
      sessionStorage.clear();
      localStorage.clear();

      window.dispatchEvent(
        new CustomEvent('sessionExpired', {
          detail: { reason: 'expired' },
        })
      );

      return Promise.reject(error);
    }

    // 🔄 Access token expired → try refresh
    if (
      status === 401 &&
      code === 'UNAUTHENTICATED' &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // ⏳ If refresh already running → queue request
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token: string) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axiosInstance(originalRequest));
            },
            reject,
          });
        });
      }

      isRefreshing = true;

      try {
        const data = await refreshTokenRequest();

        const newAccessToken = data.token;
        const newRefreshToken = data.refresh_token;

        sessionStorage.setItem('accessToken', newAccessToken);
        localStorage.setItem('refresh_token', newRefreshToken);
   localStorage.setItem('accessToken', newAccessToken);
        axiosInstance.defaults.headers.Authorization =
          `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);

        originalRequest.headers.Authorization =
          `Bearer ${newAccessToken}`;

        // ✅ ESLint-safe
        return await axiosInstance(originalRequest);

      } catch (refreshError) {
        processQueue(refreshError, null);

        sessionStorage.clear();
        localStorage.clear();

        window.dispatchEvent(
          new CustomEvent('sessionExpired', {
            detail: { reason: 'expired' },
          })
        );

        // ✅ ESLint-safe
        return await Promise.reject(refreshError);

      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);





export default axiosInstance;

/* ------------------------------------------------------------------ */
/* Fetcher */
/* ------------------------------------------------------------------ */

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, { ...config });
  return res.data;
};

/* ------------------------------------------------------------------ */
/* Mutation Fetcher */
/* ------------------------------------------------------------------ */

export const mutationFetcher = async (
  args: string | [string, any, 'POST' | 'PUT' | 'DELETE' | 'PATCH'],
  postData?: any,
  method?: 'POST' | 'PUT' | 'DELETE' | 'PATCH'
) => {
  try {
    const [url, data, httpMethod] = Array.isArray(args)
      ? args
      : [args, postData, method || 'POST'];

    const isFormData =
      typeof FormData !== 'undefined' && data instanceof FormData;

    const res = await axiosInstance({
      method: httpMethod,
      url,
      data: isFormData ? data : JSON.stringify(data),
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      },
    });

    return res.data;
  } catch (error: any) {
    console.error('API Error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'API request failed!');
  }
};


export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/user',
    login: '/login',
    register: '/api/auth/register',
    verify2FA: 'verify-otp',
    resend2FA: 'resend-otp',
    logout:'logout',
    loginhistory:'login_history'
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },

  comany: {

    getCompany: '/companylist',
    postCompany: '/company',
    deleteCompany: '/company',
    putCompany: '/companies',
    preFillCompany: '/company',
    serviceCompany: '/service',
    companyDropdown: '/getAllCompanywithChildren',
    allcompanyId: 'companyids'

  },
  users: {
    getuserapi: '/user',
    createUser: '/user',
    getByIdUser: (id: any) => `/user/${id}`,
    editUser: (id: any) => `/user/${id}`,
    deleteUser: (id: any) => `/user/${id}`,
    tokenListUser: "tokenList",
    getUserId: '/user',

  },


  service: {

    getserviceapi: '/service',
    getserviceByIdapi: '/serviceById',
    putservice: '/service',
    postservice: '/service',
    serviceCompany: '/company-services',


  },
  report: {
    getReport: '/report',
    addReport: '/report',
    companyReport: '/companyReport',
    moduletotalchart: "/module-vs-total",
    takedownrequestchart: "/takedownreq-vs-completed",
    modulewisebreakup: '/modulewise-breakup',
    averagetakedown: '/average-takedown-time',
    cumulativetakedown: '/cumulative-takedown-trend',
    socialmediadetection: 'social-media-detection',
    darkwebmentions: '/dark-web-mentions',
    tattakedowns: '/takedowns-commulative',
    getreportbyid: (id: any) => `/report/${id}`,
    editreport: (id: any) => `/report/${id}`,
      deletereport: (id: any) => `/reports/${id}`,
  },

  schedulereport: {
    schedulepost: '/schedulers',
    getscheduleapi: '/schedulers',
    deleterow: (id: any) => `/schedulers/${id}`,
    getbyid: (id: any) => `/schedulers/${id}`,
    editschedulereport: (id: any) => `/schedulers/${id}`,
    userPostReport:'/schedulers/store-user'
  },

  alert: {
    getAlert: '/alertsByGroupedCompanyId',
    getPostView: '/alertsByCompanyIdServiceId',
    alertPost: '/alert',
    alertdelete: '/alert',
    alertPreFill: '/GetAlertDetailsById',
    alertPutUpdate: '/alert',
    alertDashboard: '/AlertsByCompanyId',
    getalertusercase: 'AlertsReportedToUser',
    apiforDashboard: '/dashboard',
    zipUplode: '/upload-zip',
    updateTackdownDate: '/alert',
    downloadSheet: '/download-sample-sheet',
    takedownByGroupedCompanyId: '/takedownByGroupedCompanyId',
    dashboardissuefilter:'filterAlerts'

  },
  toakedownrequest: {
    getbyidtakedown: '/takedowns',
    updatesingletakedown: '/alert',
    bulkUpdateStatus: '/bulkUpdateStatus',
    bulkTakedownsRequested: 'bulkTakedownsRequested',
    singleUserrequest: (id: string | number) => `/alert/${id}`
  },
  generatedToken: {
    ganerateToken: '/login',
    swaggerAPIs: '/documentation'

  },
  treegraph: {
    treegraphget: '/charts/social_media_API',
    treegraphgetfirst:'/chart/structure',
    servicecounts:'/chart/service-counts',
    platformcounts:'/chart/platform-counts'

  },
  BulkUpload: {
    BulkUpload: '/BulkImportData'

  },

  Roles: {

    Roles: '/roles',
    EditRoles: "/roles",

  },
  swagger: {
    documentation: '/documentation'
  },
  VendorPerformance: {
    VendorPerformance: '/vendor-performances',
    updateVendorPerformance: '/vendor-performances',
  },

  search: {
    search: '/search'
  },


  asmreport: {
    addreport: '/backend/reports',
    editreport: '/reports',
    deletereport: '/backend/reports'
  },

  attcksurface: {
    totalAssets: "/stats/total-assets",
    ScoreChart: "vulnerabilities/score?status=open",
    byrating: "vulnerabilities/by-rating?status=open",
    issuefound: "/vulnerabilities/latest",
    techtable: "techs",
    assetsFound: "assets/all",
    map: 'map?size=10000&isRootCandidate=false&isFalsePositive=false&includeRootAsset=true',
    allissue: '/vulnerabilities',
    issueoverviewfirst: '/vulnerabilities/by-rating',
    issueoverviewtable: '/vulnerabilities-unique',
    asmreport: 'reports'
  },

  attcksurfaceassets: {
    customMeta: "/asset/custom-meta",
    overViewTable:"/assets"

  }, 
  asmpermission:{
    postpermission:'attacksurface',
    getAsmList:'attacksurfacelist',
    getpermission:'attacksurfacelist',
    updatepermission:'attacksurface',
     deletepermission: (id: any) => `/attacksurface/${id}`,
  },


    Darkwebexcel: {
    Darkwebthreat:'darkweb-mentions'
  },

};







